import HTTP from './http.service';

export const userService = {
  register,
};

async function register(user) {    
  return await HTTP.post('auth/register', { ...user });
}
